import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Grid, img, Button } from 'semantic-ui-react'
import { useHistory, NavLink } from "react-router-dom";
import moment from "moment";
import profile from "../../assets/notifications/profile.svg";
import arrow from "../../assets/home/notifications-icon.svg";

import paymentFailed from "../../assets/notifications/paymentFailed.svg";
import paymentCompleted from "../../assets/notifications/paymentCompleted.svg";
import amazonClaimed from "../../assets/notifications/amazonClaimed.svg";
import contestRes from "../../assets/notifications/contestRes.svg";
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from "react-i18next";
import { Config } from '../../common'
import { StarButton, NoNotification, Loading } from '../../components'
import { removeNotifications, getNotifications } from '../../store/UserRedux'
import renderHTML from 'react-render-html';

const NotificationsScreen = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  const history = useHistory();
  const token = useSelector((state) => state.auth.token)
  const notifications = useSelector((state) => state.user.notifications)
  const isFetching = useSelector((state) => state.user.isFetching)
  const isDelete = useSelector((state) => state.user.isDelete)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const arrowClick = () => {
    window.scrollTo(0, 0)
  }



  const removeNotice = (item) => {
    dispatch(removeNotifications({ notifications: [item._id], token }))
  }

  useEffect(() => {
    if (isDelete) {
      dispatch(getNotifications({ token }))
    }
  }, [isDelete]);

  if (isFetching) {
    return <Loading />
  }

  if (notifications && notifications.count == 0) {
    return <NoNotification />
  }

  const randerImgs = (type) => {
    if (type === 'profile-update') {
      return <img className="dice_img" src={profile} />
    } else if (type === 'payment-failed') {
      return <img className="dice_img" src={paymentFailed} />
    } else if (type === 'payment-completed') {
      return <img className="dice_img" src={paymentCompleted} />
    } else if (type === 'giftcard') {
      return <img className="dice_img" src={amazonClaimed} />
    } else if (type === 'contest-results') {
      return <img className="dice_img" src={contestRes} />
    } else {
      return <img className="dice_img" src={profile} />
    }
  }

  return (
    <div className="container">
      {/* section 1 */}

      <div className="notifection_order" style={{ marginTop: "90px" }}>
        <h4>{t("notifiction.titel")}</h4>
        <p>{t("notifiction.para")}</p>
      </div>

      {/* section 2 */}
      <div className="please notifectionList">
        {notifications && notifications.data ? notifications.data.map((item, key) => {
          let newDate = moment.utc() - moment.utc(item?.createdAt)
          return <div key={key} className={(item.type === 'profile-update' || item.type === 'payment-completed') ? "completes yelowBorder" : "completes"}>
            <Grid onClick={() => removeNotice(item)}>
              <Grid.Row>
                <Grid.Column mobile={16} tablet={2} computer={2}>
                  {randerImgs(item.type)}
                </Grid.Column>
                <Grid.Column mobile={16} tablet={10} computer={10}>
                  <h5>
                    <div className="now">{Config.parseDurationNotification(newDate)}</div>
                    {renderHTML(item.text || "<p></p>")}</h5>
                  <p>{renderHTML(item.details || "<p></p>")}</p>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={4} computer={4}>
                  {item.buttonType && (<div className="updates_box">
                    {/* <StarButton background={(item.type === 'profile-update' || item.type === 'payment-completed') ? 'mainBg smallButHight' : null} title={item.buttonType} onClickAction={() => history.push(item.route)} disableStar={(item.type === 'profile-update' || item.type === 'payment-completed') ? false : true} /> */}
                    <StarButton title={item.buttonType} onClickAction={() => history.push(item.route)} disableStar={true} />
                  </div>)}
                </Grid.Column>
              </Grid.Row>
            </Grid>

          </div>
        }) : null}

      </div>
      <img src={arrow} className="arrow" onClick={() => arrowClick()} />
    </div>
  );
};

export default NotificationsScreen